// Hintergrundfarbe der Website, im Admin-Bereich einstellbar.
//
// Sie liegt unter /gallery/design: /gallery ist öffentlich lesbar und nur für
// den Admin schreibbar. /config schied aus — dort erlauben die Regeln nur die
// namentlich aufgeführten Kinder.
//
// Gesetzt wird sie als CSS-Variable am Wurzelelement. Ohne Datenbank gilt, was
// in index.css steht; die Seite ist also auch dann vollständig.

import { ref, onValue, set } from 'firebase/database';
import { database } from './firebase';

export const STANDARD_HINTERGRUND = '#e9f8f5';
// Zweite, etwas kräftigere Farbe für die Verläufe in Kopfbereich und Leisten.
const STANDARD_HINTERGRUND2 = '#d8f0ea';

const HEXFARBE = /^#[0-9a-fA-F]{6}$/;

export function istFarbe(wert) {
  return typeof wert === 'string' && HEXFARBE.test(wert);
}

// Begleitfarbe für die Verläufe: dieselbe Farbe, etwas abgedunkelt. Für die
// Standardfarbe ist das Paar fest hinterlegt, damit die Seite nach dem
// Zurücksetzen exakt so aussieht wie zuvor — die Rechnung träfe den von Hand
// gewählten, etwas satteren Mintton nicht.
export function begleitfarbe(hex) {
  if (!istFarbe(hex)) {
    return STANDARD_HINTERGRUND2;
  }
  if (hex.toLowerCase() === STANDARD_HINTERGRUND) {
    return STANDARD_HINTERGRUND2;
  }
  const zahl = parseInt(hex.slice(1), 16);
  const kanaele = [(zahl >> 16) & 255, (zahl >> 8) & 255, zahl & 255]
    .map((wert) => Math.round(wert * 0.93))
    .map((wert) => wert.toString(16).padStart(2, '0'));
  return `#${kanaele.join('')}`;
}

export function normalizeDesign(raw) {
  const farbe = raw && raw.backgroundColor;
  return { backgroundColor: istFarbe(farbe) ? farbe.toLowerCase() : STANDARD_HINTERGRUND };
}

export function applyDesign(design) {
  const wurzel = document.documentElement;
  wurzel.style.setProperty('--background-color', design.backgroundColor);
  wurzel.style.setProperty('--background-color2', begleitfarbe(design.backgroundColor));
}

// Nimmt die Variablen wieder heraus, damit der Admin-Bereich nicht in der
// Farbe der Website erscheint.
export function clearDesign() {
  const wurzel = document.documentElement;
  wurzel.style.removeProperty('--background-color');
  wurzel.style.removeProperty('--background-color2');
}

export function subscribeDesign(callback) {
  return onValue(
    ref(database, 'gallery/design'),
    (snapshot) => callback(normalizeDesign(snapshot.val())),
    () => callback(normalizeDesign(null))
  );
}

export function writeDesign(design) {
  return set(ref(database, 'gallery/design'), { backgroundColor: design.backgroundColor });
}
